import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FirebaseService } from 'src/app/services/firebase.service';
import { Product, Image } from '../../interfaces'
import { environment } from '../../../environments/environment'
import { UserService } from 'src/app/services/user.service';
import { ProductService } from 'src/app/services/product.service';
import { ActivatedRoute } from '@angular/router';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare const L: any;

@Component({
  selector: 'app-editproduct',
  templateUrl: './editproduct.component.html',
  styleUrls: ['./editproduct.component.css']
})
export class EditProductComponent implements AfterViewInit, OnInit {

  feature_form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    value: new FormControl('', [Validators.required])
  })

  highlights_form: FormGroup = new FormGroup({
    highlight: new FormControl('', [Validators.required])
  })

  product: Product = {
    image: null,
    pid: null,
    auctionAmount: 0,
    productImages: [],
    startsAt: null,
    endsAt: null,
    prevBid: null,
    productFeatures: [],
    productTitle: null,
    productHiglight: [],
    manufacturer: null,
    productDescription: "",
    price: null,
    images: [],
    pickupAddress: { lat: null, lon: null }
  }

  pid: number = 0;

  constructor(
    private _toastr: ToastrService,
    private _firebaseService: FirebaseService,
    private _userService: UserService,
    private _productService: ProductService,
    private _route: ActivatedRoute,
  ) { }

  ngOnInit() {

    this._route.params.subscribe(params => {
      this.pid = params['pid'];
      this._productService.fetchProductDetail(this.pid).subscribe(
        async (data: any) => {
          console.log(data.product)

          var productData: Product = data.product;
          this.product.pid = productData.pid;
          this.product.productTitle = productData.productTitle;
          this.product.productDescription = productData.productDescription;
          this.product.manufacturer = productData.manufacturer;
          this.product.auctionAmount = productData.auctionAmount;
          this.product.price = productData.price;
          this.product.pickupAddress = productData.pickupAddress;
          this.product.productHiglight = productData.productHiglight;
          this.product.productFeatures = productData.productFeatures;
          this.product.startsAt = productData.startsAt;
          this.product.endsAt = productData.endsAt;


          productData.images.forEach(image => {

            this._firebaseService.getDownloadUrl(image).subscribe(
              (url: string) => {
                var productImage: Image = {
                  url: url,
                  path: image
                }

                this.product.productImages.push(productImage)
              }
            )
          })

          this.product.image = await this._firebaseService.getDownloadUrl(productData.images[0]).toPromise();

          var mymap = L.map('map').setView([this.product.pickupAddress.lat, this.product.pickupAddress.lon], 13);
          L.tileLayer(environment.map_url, {
            maxZoom: 20,
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1,
          }).addTo(mymap);

          L.marker([this.product.pickupAddress.lat, this.product.pickupAddress.lon]).addTo(mymap);
        },
        (err: any) => {
          this._toastr.error(err.error.msg)
        }
      )
    })
  }

  ngAfterViewInit() {
  }

  addFeature() {

    if (this.product['productFeatures'] == undefined) {
      this.product.productFeatures = []
    }

    this.product.productFeatures.push(this.feature_form.value)
    this.feature_form.setValue({
      name: "",
      value: ""
    })
  }

  addHighlight() {

    if (this.product['productHiglight'] == undefined) {
      this.product.productHiglight = []
    }

    this.product.productHiglight.push(this.highlights_form.value.highlight)
    this.highlights_form.setValue({
      highlight: ""
    })
  }

  removeFeature(i: number) {
    this.product.productFeatures.splice(i, 1);
  }

  removePrice() {
    this.product.price = null;
  }

  removeHighLight(i: number) {
    this.product.productHiglight.splice(i, 1)
  }

  update() {

    var images: string[] = []
    this.product.productImages.forEach((image: Image) => {
      images.push(image.path)
    });

    var data: Product = {
      price: this.product.price,
      productHiglight: this.product.productHiglight,
      productFeatures: this.product.productFeatures,
      productTitle: this.product.productTitle,
      manufacturer: this.product.manufacturer,
      productDescription: this.product.productDescription,
      images: images,
      pickupAddress: this.product.pickupAddress,
      pid: this.product.pid,
      auctionAmount: this.product.auctionAmount,
      startsAt: this.product.startsAt,
      endsAt: this.product.endsAt,

      productImages: null,
      image: null,
      prevBid: null,
    }

    this._userService.editProduct( this.pid, data).subscribe(
      (data: any) => {
        this._toastr.success("", data.msg)
      },

      error => {
        this._toastr.error("", error.error.msg)
      }
    )
  }

  addImage(data: any) {

    const files = data.target.files
    const file: File = files[0]
    const path = `/product/${file.name}`

    if (this.product.productImages.length < 5) {
      if (file.size < 5 * 1024 * 1024) {

        this._toastr.info(`Uploading ${file.name}`)
        this._firebaseService.uploadFile(path, file).then(

          (res: string) => {
            console.log(res)
            var newImage: Image = {
              url: res,
              path: path
            }

            this.product.productImages.push(newImage)
          },

          (err: any) => {
            console.log(err)
            this._toastr.error(`Error while uploading ${file.name}`)
          }

        )
      } else {
        this._toastr.error("Please Upload an Image of size less than 5MB")
      }
    } else {
      this._toastr.error("Max 5 images allowed ")
    }
  }

  removeImage(i: number) {
    this._firebaseService.deleteFile(this.product.productImages[i].path)
    this.product.productImages.splice(i, 1)
  }

}
